import { z } from "zod";

import { wrapSchema } from "@smart/itops-utils-basic";

export const stashSchema = z.object({
  email: z.string(),
  provider: z.string(),
  username: z.string(),
  token: z.string(),
  clientId: z.string(),
  region: z.string(),
});

export const stashGuard = wrapSchema(stashSchema);

export type Stash = z.infer<typeof stashSchema>;
